import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  FormControlLabel,
  Checkbox,
  CardContent,
  Card,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {
  approveDippingCell,
  createDailyParaCoagulant,
  getDailyParaOfDippingCellDetails,
} from "./Services";
import dayjs from "dayjs";
import { set } from "react-hook-form";
import { use } from "react";
import { toast, ToastContainer } from "react-toastify";
import Button from "../../components/Button/Button";
import { useSelector } from "react-redux";

const DippingCogulant = () => {
  const { username, is_supervisor } = useSelector((state) => state.userState);
  const [dippingData, setDippingData] = React.useState([]);
  const [checkedRows, setCheckedRows] = useState({});
  const [isApproved, setIsApproved] = useState(false);
  const [localModifiedAt, setLocalModifiedAt] = useState({});
  const [hotConductivity, setHotConductivity] = useState(
    dippingData?.coagulant_parameter?.coagulant_range?.hot_conductivity || null
  );
  const [rangType, setRangeType] = useState();

  const [coldConductivity, setColdConductivity] = React.useState(
    dippingData?.coagulant_parameter?.coagulant_range?.[0]?.cold_conductivity
  );
  const [dippingHotConductivity, setDippingHotConductivity] = React.useState(
    dippingData?.coagulant_parameter?.coagulant_dipping_tank?.hot_conductivity
  );
  const [dippingColdConductivity, setDippingColdConductivity] = React.useState(
    dippingData?.coagulant_parameter?.coagulant_dipping_tank?.cold_conductivity
  );

  console.log("checkedRowscheckedRows", checkedRows);
  const [rowData, setRowData] = useState({
    range: {
      minimum: {},
      maximum: {},
    },
    dippingTank: {},
    maturationTank: {},
  });

  useEffect(() => {
    setHotConductivity(
      dippingData?.coagulant_parameter?.coagulant_range?.hot_conductivity ||
        null
    );
    setColdConductivity(
      dippingData?.coagulant_parameter?.coagulant_range?.cold_conductivity ||
        null
    );
    setDippingHotConductivity(
      dippingData?.coagulant_parameter?.coagulant_dipping_tank
        ?.hot_conductivity || null
    );
    setDippingColdConductivity(
      dippingData?.coagulant_parameter?.coagulant_dipping_tank
        ?.cold_conductivity || null
    );
  }, [dippingData]);

  console.log(
    "hotConductivity",
    hotConductivity,
    dippingData?.coagulant_parameter
  );

  useEffect(() => {
    handleGetData();
  }, []);

  const handleGetData = async () => {
    try {
      const resp = await getDailyParaOfDippingCellDetails();
      if (resp.status == 200 || resp.status == 201) {
        setDippingData(resp.data.payload);
      }
    } catch (error) {
      setDippingData([]);
    }
  };
  const getRangeData = (type) => {
    return (
      dippingData?.coagulant_parameter?.coagulant_range?.coagulant_range?.find(
        (range) => range.range_type === type
      ) || {}
    );
  };

  const minimumRange = getRangeData(0);
  const maximumRange = getRangeData(1);

  console.log("minimumRange", minimumRange);
  console.log("maximumRange", maximumRange);
  const ranges = {
    minimum: {
      temp: minimumRange.temp || "",
      specific_gravity: minimumRange.specific_gravity || "",
      foam_test_1: minimumRange.foam_test_1 || "",
      foam_test_2: minimumRange.foam_test_2 || "",
      foam_test_3: minimumRange.foam_test_3 || "",
      remark_time: minimumRange.remark_time || "",
      operator: minimumRange.operator || username,
      supervisor: minimumRange.supervisor || "",
      is_submitted: minimumRange.is_submitted || false,
      id: minimumRange.id || "",
      minimumDate: minimumRange.modified_at
        ? dayjs(minimumRange.modified_at).format("HH:mm:ss")
        : "",
    },
    maximum: {
      temp: maximumRange.temp || "",
      specific_gravity: maximumRange.specific_gravity || "",
      foam_test_1: maximumRange.foam_test_1 || "",
      foam_test_2: maximumRange.foam_test_2 || "",
      foam_test_3: maximumRange.foam_test_3 || "",
      remark_time: maximumRange.remark_time || "",
      is_submitted: maximumRange.is_submitted || false,
      id: maximumRange.id || "",
      operator: maximumRange.operator || username,
      supervisor: maximumRange.supervisor || "",
      maximumDate: maximumRange.modified_at
        ? dayjs(maximumRange.modified_at).format("HH:mm:ss")
        : "",
    },
  };
  const notifyError = (message) =>
    toast.error(message, {
      theme: "colored",
      position: toast.POSITION.TOP_RIGHT,
      toastClassName: "custom-toast",
    });

  const notify = (message) =>
    toast.success(message, {
      theme: "colored",
      position: toast.POSITION.TOP_RIGHT,
      toastClassName: "custom-toast",
    });

  const inputStyle = {
    width: "100%",
    border: "1px solid #ddd",
    padding: "4px",
  };

  const [formData, setFormData] = React.useState({
    coagulant_range: {
      coagulant_range: [
        {
          range_type: rangType,
          temp: "",
          specific_gravity: "",
          foam_test_1: "",
          foam_test_2: "",
          foam_test_3: "",
          remark_time: "",
        },
        {
          range_type: rangType,
          temp: "",
          specific_gravity: "",
          foam_test_1: "",
          foam_test_2: "",
          foam_test_3: "",
          remark_time: "",
        },
      ],
      hot_conductivity: "",
      cold_conductivity: "",
    },
    coagulant_dipping_tank: {
      coagulant_dipping_tank: [],
      hot_conductivity: "",
      cold_conductivity: "",
    },
  });
  const handleCheckboxClick = async (type, index, rangeType, id) => {
    console.log("iddsfdsf", id);
    const rowKey =
      type === "Range" ? `${type}_${rangeType}` : `${type}_${index}`;
    const isCurrentlyChecked = checkedRows[rowKey] || false;
    const newCheckedState = !isCurrentlyChecked;

    // Update the checkbox state immediately
    setCheckedRows((prev) => ({
      ...prev,
      [rowKey]: newCheckedState,
    }));

    // If unchecking, just return without making API call
    if (!newCheckedState) {
      return;
    }

    try {
      let payload;

      if (type === "Range") {
        const rangeData = rowData.range[rangeType];
        console.log("rangeData", rangeData);
        payload = {
          cell_type: "Range",
          range_type: rangeType === "minimum" ? 0 : 1,
          specific_gravity:
            rangeData.specific_gravity || ranges[rangeType].specific_gravity,
          temp: rangeData.temp || ranges[rangeType].temp,
          foam_test_1: rangeData.foam_test_1 || ranges[rangeType].foam_test_1,
          foam_test_2: rangeData.foam_test_2 || ranges[rangeType].foam_test_2,
          foam_test_3: rangeData.foam_test_3 || ranges[rangeType].foam_test_3,
          remark_time: rangeData.remark_time || ranges[rangeType].remark_time,
          hot_conductivity:
            hotConductivity || ranges[rangeType].hot_conductivity,
          cold_conductivity:
            coldConductivity || ranges[rangeType].cold_conductivity,
          position: rangeType === "minimum" ? 0 : 1,
        };
      } else if (type === "DippingTank") {
        const tankData = rowData.DippingTank[index];
        console.log("tankData", tankData);
        const row = dippingData?.daily_dipping_tank?.[index];
        payload = {
          cell_type: "DippingTank",
          temp: tankData?.temp || row?.temp,
          tank_type: DEFAULT_TANK_NAMES.DippingTank[index], // Added tank_type
          specific_gravity: tankData?.specific_gravity || row?.specific_gravity,
          foam_test_1: tankData?.foam_test_1 || row?.foam_test_1,
          foam_test_2: tankData?.foam_test_2 || row?.foam_test_2,
          foam_test_3: tankData?.foam_test_3 || row?.foam_test_3,
          remark_time: tankData?.remark_time || row?.remark_time,
          hot_conductivity: dippingHotConductivity || row?.hot_conductivity,
          cold_conductivity: dippingColdConductivity || row?.cold_conductivity,
          position: index,
        };
      }
      if (id !== "") {
        payload.obj_id = id;
      }

      console.log("payload", payload);
      const response = await createDailyParaCoagulant(payload);
      if (response.status === 200 || response.status === 201) {
        notify(response.data.message);
        handleGetData();
      }
    } catch (error) {
      // Revert checkbox if API call fails
      setCheckedRows((prev) => ({
        ...prev,
        [rowKey]: !newCheckedState,
      }));
      notifyError(error.response?.data?.message || "Submission failed");
    }
  };

  const handleApprove = () => {
    if (is_supervisor) {
      setIsApproved(true);
    } else {
      notifyError("You don't have access");
    }
  };

  // const handleInputChange = (section, index, field, value) => {
  //   setFormData((prev) => {
  //     if (section === "range") {
  //       setRangeType(index);
  //       // Create a copy of existing ranges or initialize if empty
  //       const newRanges = [...(prev.coagulant_range.coagulant_range || [])];

  //       // Preserve existing data for both rows
  //       if (!newRanges[0]) {
  //         newRanges[0] = {
  //           range_type: 0,
  //           temp: "",
  //           specific_gravity: "",
  //           foam_test_1: "",
  //           foam_test_2: "",
  //           foam_test_3: "",
  //           remark_time: "",
  //         };
  //       }
  //       if (!newRanges[1]) {
  //         newRanges[1] = {
  //           range_type: 1,
  //           temp: "",
  //           specific_gravity: "",
  //           foam_test_1: "",
  //           foam_test_2: "",
  //           foam_test_3: "",
  //           remark_time: "",
  //         };
  //       }

  //       // Update only the specific field for the current row
  //       newRanges[index] = {
  //         ...newRanges[index], // Preserve other fields
  //         [field]: value,
  //         range_type: index,
  //       };

  //       return {
  //         ...prev,
  //         coagulant_range: {
  //           ...prev.coagulant_range,
  //           coagulant_range: newRanges,
  //         },
  //       };
  //     } else if (section === "dipping") {
  //       const existingTanks = [
  //         ...(prev.coagulant_dipping_tank.coagulant_dipping_tank || []),
  //       ];

  //       // Initialize empty slots with proper structure
  //       while (existingTanks.length <= index) {
  //         existingTanks.push({
  //           tank_type: "",
  //           temp: "",
  //           specific_gravity: "",
  //           foam_test_1: "",
  //           foam_test_2: "",
  //           foam_test_3: "",
  //           remark_time: "",
  //         });
  //       }

  //       // Update the specific index with new value while preserving other fields
  //       existingTanks[index] = {
  //         ...existingTanks[index],
  //         [field]: value,
  //       };

  //       return {
  //         ...prev,
  //         coagulant_dipping_tank: {
  //           ...prev.coagulant_dipping_tank,
  //           coagulant_dipping_tank: existingTanks,
  //         },
  //       };
  //     } else if (section === "conductivity") {
  //       console.log("sadfhsjkfbhsjkab");
  //       const [tankType, conductivityType] = field.split("_");

  //       console.log("tankTypetankType", conductivityType, tankType);
  //       // Check if you're updating hot_conductivity or cold_conductivity
  //       if (tankType === "coagulant_range") {
  //         return {
  //           ...prev,
  //           coagulant_range: {
  //             ...prev.coagulant_range,
  //             [conductivityType]: value, // Update hot_conductivity or cold_conductivity
  //           },
  //         };
  //       } else if (tankType === "coagulant_dipping_tank") {
  //         return {
  //           ...prev,
  //           coagulant_dipping_tank: {
  //             ...prev.coagulant_dipping_tank,
  //             [conductivityType]: value, // Update hot_conductivity or cold_conductivity
  //           },
  //         };
  //       }
  //     }
  //     return prev;
  //   });
  // };
  // const handleInputChange = (type, field, value, index, rangeType) => {
  //   // Create a unique key for the cell
  //   const cellKey = type === "Range" 
  //     ? `${type}_${rangeType}_${field}`
  //     : `${type}_${index}_${field}`;

  //   // Check if previous data is saved
  //   if (type === "Range") {
  //     if (rangeType === "maximum" && !checkedRows["Range_minimum"]) {
  //       if (!rowData.range?.[rangeType]?.toasterShown?.[field]) {
  //         toast.warning("Save the manual data", {
  //           theme: "colored",
  //           position: toast.POSITION.TOP_RIGHT,
  //           toastClassName: "custom-toast",
  //           toastId: cellKey // Prevent duplicate toasts for the same cell
  //         });
  //         // Mark this cell's toaster as shown
  //         setRowData(prev => ({
  //           ...prev,
  //           range: {
  //             ...prev.range,
  //             [rangeType]: {
  //               ...(prev.range?.[rangeType] || {}),
  //               toasterShown: {
  //                 ...(prev.range?.[rangeType]?.toasterShown || {}),
  //                 [field]: true
  //               }
  //             }
  //           }
  //         }));
  //       }
  //       return;
  //     }
  //   } else if (type === "DippingTank") {
  //     // Check if range data is saved
  //     if (!checkedRows["Range_minimum"] || !checkedRows["Range_maximum"]) {
  //       if (!rowData[type]?.[index]?.toasterShown?.[field]) {
  //         toast.warning("Save the manual data", {
  //           theme: "colored",
  //           position: toast.POSITION.TOP_RIGHT,
  //           toastClassName: "custom-toast",
  //           toastId: cellKey // Prevent duplicate toasts for the same cell
  //         });
  //         setRowData(prev => ({
  //           ...prev,
  //           [type]: {
  //             ...prev[type],
  //             [index]: {
  //               ...(prev[type]?.[index] || {}),
  //               toasterShown: {
  //                 ...(prev[type]?.[index]?.toasterShown || {}),
  //                 [field]: true
  //               }
  //             }
  //           }
  //         }));
  //       }
  //       return;
  //     }
  //     // Check if previous tank data is saved
  //     if (index > 0 && !checkedRows[`${type}_${index - 1}`]) {
  //       if (!rowData[type]?.[index]?.toasterShown?.[field]) {
  //         toast.warning("Save the manual data", {
  //           theme: "colored",
  //           position: toast.POSITION.TOP_RIGHT,
  //           toastClassName: "custom-toast",
  //           toastId: cellKey // Prevent duplicate toasts for the same cell
  //         });
  //         setRowData(prev => ({
  //           ...prev,
  //           [type]: {
  //             ...prev[type],
  //             [index]: {
  //               ...(prev[type]?.[index] || {}),
  //               toasterShown: {
  //                 ...(prev[type]?.[index]?.toasterShown || {}),
  //                 [field]: true
  //               }
  //             }
  //           }
  //         }));
  //       }
  //       return;
  //     }
  //   }

  //   // Reset toaster flag when input is allowed
  //   setRowData((prev) => {
  //     if (type === "Range") {
  //       return {
  //         ...prev,
  //         range: {
  //           ...prev.range,
  //           [rangeType]: {
  //             ...(prev.range?.[rangeType] || {}),
  //             [field]: value,
  //             position: index,
  //             toasterShown: {
  //               ...(prev.range?.[rangeType]?.toasterShown || {}),
  //               [field]: false
  //             }
  //           },
  //         },
  //       };
  //     } else {
  //       return {
  //         ...prev,
  //         [type]: {
  //           ...prev[type],
  //           [index]: {
  //             ...(prev[type]?.[index] || {}),
  //             [field]: value,
  //             position: index,
  //             toasterShown: {
  //               ...(prev[type]?.[index]?.toasterShown || {}),
  //               [field]: false
  //             }
  //           },
  //         },
  //       };
  //     }
  //   });
  // };

  const handleInputChange = (type, field, value, index, rangeType) => {
    // Create a unique key for the cell
    const cellKey = type === "Range" 
      ? `${type}_${rangeType}_${field}`
      : `${type}_${index}_${field}`;

    // Check if previous data is saved
    if (type === "Range") {
      if (rangeType === "maximum") {
        // Check if minimum range has any filled fields but not checked
        const minimumData = rowData.range?.minimum || {};
        const hasMinimumData = Object.keys(minimumData).some(key => 
          key !== 'toasterShown' && minimumData[key]
        );
        
        if (hasMinimumData && !checkedRows["Range_minimum"]) {
          if (!rowData.range?.[rangeType]?.toasterShown?.[field]) {
            toast.warning("Save the manual data", {
              theme: "colored",
              position: toast.POSITION.TOP_RIGHT,
              toastClassName: "custom-toast"
            });
            setRowData(prev => ({
              ...prev,
              range: {
                ...prev.range,
                [rangeType]: {
                  ...(prev.range?.[rangeType] || {}),
                  toasterShown: {
                    ...(prev.range?.[rangeType]?.toasterShown || {}),
                    [field]: true
                  }
                }
              }
            }));
          }
          return;
        }
      }
    } else if (type === "DippingTank") {
      // Check if range data is filled but not saved
      const minimumData = rowData.range?.minimum || {};
      const maximumData = rowData.range?.maximum || {};
      const hasRangeData = [...Object.keys(minimumData), ...Object.keys(maximumData)].some(key => 
        key !== 'toasterShown' && (minimumData[key] || maximumData[key])
      );

      if (hasRangeData && (!checkedRows["Range_minimum"] || !checkedRows["Range_maximum"])) {
        if (!rowData[type]?.[index]?.toasterShown?.[field]) {
          toast.warning("Save the manual data", {
            theme: "colored",
            position: toast.POSITION.TOP_RIGHT,
            toastClassName: "custom-toast"
          });
          setRowData(prev => ({
            ...prev,
            [type]: {
              ...prev[type],
              [index]: {
                ...(prev[type]?.[index] || {}),
                toasterShown: {
                  ...(prev[type]?.[index]?.toasterShown || {}),
                  [field]: true
                }
              }
            }
          }));
        }
        return;
      }

      // Check if previous tank data is filled but not saved
      if (index > 0) {
        const prevTankData = rowData[type]?.[index - 1] || {};
        const hasPrevTankData = Object.keys(prevTankData).some(key => 
          key !== 'toasterShown' && prevTankData[key]
        );

        if (hasPrevTankData && !checkedRows[`${type}_${index - 1}`]) {
          if (!rowData[type]?.[index]?.toasterShown?.[field]) {
            toast.warning(`Save the manual data`, {
              theme: "colored",
              position: toast.POSITION.TOP_RIGHT,
              toastClassName: "custom-toast"
            });
            setRowData(prev => ({
              ...prev,
              [type]: {
                ...prev[type],
                [index]: {
                  ...(prev[type]?.[index] || {}),
                  toasterShown: {
                    ...(prev[type]?.[index]?.toasterShown || {}),
                    [field]: true
                  }
                }
              }
            }));
          }
          return;
        }
      }
    } else if (type === "MaturationTank") {
      // Check if all dipping tanks are saved
      const dippingTankCount = dippingData?.daily_dipping_tank?.length || 0;
      const lastDippingTankData = rowData.DippingTank?.[dippingTankCount - 1] || {};
      const hasLastDippingTankData = Object.keys(lastDippingTankData).some(key => 
        key !== 'toasterShown' && lastDippingTankData[key]
      );

      if (hasLastDippingTankData && !checkedRows[`DippingTank_${dippingTankCount - 1}`]) {
        if (!rowData[type]?.[index]?.toasterShown?.[field]) {
          toast.warning("Save the manual data", {
            theme: "colored",
            position: toast.POSITION.TOP_RIGHT,
            toastClassName: "custom-toast"
          });
          setRowData(prev => ({
            ...prev,
            [type]: {
              ...prev[type],
              [index]: {
                ...(prev[type]?.[index] || {}),
                toasterShown: {
                  ...(prev[type]?.[index]?.toasterShown || {}),
                  [field]: true
                }
              }
            }
          }));
        }
        return;
      }

      // Check if previous maturation tank data is filled but not saved
      if (index > 0) {
        const prevTankData = rowData[type]?.[index - 1] || {};
        const hasPrevTankData = Object.keys(prevTankData).some(key => 
          key !== 'toasterShown' && prevTankData[key]
        );

        if (hasPrevTankData && !checkedRows[`${type}_${index - 1}`]) {
          if (!rowData[type]?.[index]?.toasterShown?.[field]) {
            toast.warning(`Save the manual data`, {
              theme: "colored",
              position: toast.POSITION.TOP_RIGHT,
              toastClassName: "custom-toast"
            });
            setRowData(prev => ({
              ...prev,
              [type]: {
                ...prev[type],
                [index]: {
                  ...(prev[type]?.[index] || {}),
                  toasterShown: {
                    ...(prev[type]?.[index]?.toasterShown || {}),
                    [field]: true
                  }
                }
              }
            }));
          }
          return;
        }
      }
    }

    // Reset toaster flag when input is allowed
    setRowData((prev) => {
      if (type === "Range") {
        return {
          ...prev,
          range: {
            ...prev.range,
            [rangeType]: {
              ...(prev.range?.[rangeType] || {}),
              [field]: value,
              position: index,
              toasterShown: {
                ...(prev.range?.[rangeType]?.toasterShown || {}),
                [field]: false
              }
            },
          },
        };
      } else {
        return {
          ...prev,
          [type]: {
            ...prev[type],
            [index]: {
              ...(prev[type]?.[index] || {}),
              [field]: value,
              position: index,
              toasterShown: {
                ...(prev[type]?.[index]?.toasterShown || {}),
                [field]: false
              }
            },
          },
        };
      }
    });
  };

  const navigate = useNavigate();
  const handleSubmitData = async () => {
    const params = {
      cell_type: "Coagulant",
      id: dippingData?.coagulant_parameter?.id,
      is_approved: true,
    };
    try {
      const resp = await approveDippingCell(params);
      if (resp.status == 200 || resp.status == 201) {
        handleGetData();
        notify(resp.data.message);
        setIsApproved(false);
      }
    } catch (error) {
      notifyError(error.response.data.message);
      setIsApproved(false);
      console.log("error", error);
    }
  };

  const handleSubmit = async () => {
    navigate("/dipping-parameters");
  };
  const isRowChecked = (type, index, rangeType) => {
    const rowKey =
      type === "Range" ? `${type}_${rangeType}` : `${type}_${index}`;
    return checkedRows[rowKey] || false;
  };
  console.log("dippingHotConductivity");
  useEffect(() => {
    // Initialize checkedRows based on API data

    const newCheckedRows = {};

    // Initialize range rows
    dippingData?.coagulant_parameter?.coagulant_range?.coagulant_range.forEach(
      (range) => {
        const key = range.range_type === 0 ? "Range_minimum" : "Range_maximum";
        newCheckedRows[key] = range.is_submitted || false;
      }
    );

    // Initialize dipping tank rows - Fix: Use position as the index
    dippingData?.coagulant_parameter?.coagulant_dipping_tank?.coagulant_dipping_tank?.forEach(
      (tank) => {
        newCheckedRows[`DippingTank_${tank.position}`] =
          tank.is_submitted || false;
      }
    );

    setCheckedRows(newCheckedRows);
  }, [dippingData]);

  const areAllRowsChecked = () => {
    // Check if there are any rows to validate
    if (!dippingData?.coagulant_parameter) return false;

    // Check range rows
    const rangeRows =
      dippingData.coagulant_parameter.coagulant_range?.coagulant_range || [];
    const areRangesChecked = rangeRows.every((range) => {
      const key = range.range_type === 0 ? "Range_minimum" : "Range_maximum";
      return checkedRows[key];
    });

    // Check dipping tank rows
    const dippingTankRows =
      dippingData.coagulant_parameter.coagulant_dipping_tank
        ?.coagulant_dipping_tank || [];
    const areDippingTanksChecked = dippingTankRows.every((tank) => {
      return checkedRows[`DippingTank_${tank.position}`];
    });

    return areRangesChecked && areDippingTanksChecked;
  };
  const DEFAULT_TANK_NAMES = {
    DippingTank: ["D2", "D3", "D4"],
   
  };
  console.log("sdlndsknfjkdsf", ranges.minimum.supervisor);
  return (
    <div className="page-wraper">
      <ToastContainer />
      <div className="page-header">
        <Link to="/dipping-cell" className="page-back-btn">
          <ArrowBackIcon />
          <span style={{ width: "max-content" }}>
            Daily Parameter of Coagulant
          </span>
        </Link>
      </div>
      <Paper sx={{ width: "100%" }}>
        <TableContainer>
          <Table size="small" className="Table-dipping-cells">
            <TableHead>
              <TableRow sx={{ backgroundColor: "#1d407d" }}>
                <TableCell
                  colSpan={13}
                  align="center"
                  sx={{ color: "white", borderRight: "1px solid white" }}
                >
                  Daily Parameter of Coagulant
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell colSpan={2}>Parameter</TableCell>
                <TableCell>Temp</TableCell>
                <TableCell>Specific Gravity</TableCell>
                <TableCell colSpan={3}>Foam Test</TableCell>
                <TableCell>Remark Time</TableCell>

                <TableCell>HOT Conductivity (μs/cm)</TableCell>
                <TableCell> Cold Conductivity (μs/cm)</TableCell>
                <TableCell>Time</TableCell>
                <TableCell>Operator Name</TableCell>
                <TableCell>Sup(Prod/QA)</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {/* Range Section */}
              <TableRow>
                <TableCell rowSpan={2}>Range</TableCell>
                <TableCell>Minimum</TableCell>
                <TableCell>
                  {" "}
                  {/* <input
                    type="text"
                    defaultValue={ranges.minimum.temp}
                    onChange={(e) =>
                      handleInputChange(
                        "Range",
                        "temp",
                        e.target.value,
                        null,
                        "minimum"
                      )
                    }
                    disabled={checkedRows?.[`Range_minimum`] || false}
                    style={inputStyle}
                  /> */}
                  {ranges.minimum.temp}
                </TableCell>
                <TableCell>
                  {" "}
                  {/* <input
                    type="text"
                    defaultValue={ranges.minimum.specific_gravity}
                    onChange={(e) =>
                      handleInputChange(
                        "Range",
                        "specific_gravity",
                        e.target.value,
                        null,
                        "minimum"
                      )
                    }
                    disabled={checkedRows?.[`Range_minimum`] || false}
                    style={inputStyle}
                  /> */}
                  {ranges.minimum.specific_gravity}
                </TableCell>
                <TableCell>
                  {" "}
                  {/* <input
                    type="text"
                    defaultValue={ranges.minimum.foam_test_1}
                    onChange={(e) =>
                      handleInputChange(
                        "Range",
                        "foam_test_1",
                        e.target.value,
                        null,
                        "minimum"
                      )
                    }
                    disabled={checkedRows?.[`Range_minimum`] || false}
                    style={inputStyle}
                  /> */}
                  {ranges.minimum.foam_test_1}
                </TableCell>
                <TableCell>
                  {" "}
                  {/* <input
                    type="text"
                    defaultValue={ranges.minimum.foam_test_2}
                    onChange={(e) =>
                      handleInputChange(
                        "Range",
                        "foam_test_2",
                        e.target.value,
                        null,
                        "minimum"
                      )
                    }
                    disabled={checkedRows?.[`Range_minimum`] || false}
                    style={inputStyle}
                  /> */}
                  {ranges.minimum.foam_test_2}
                </TableCell>
                <TableCell>
                  {" "}
                  {/* <input
                    type="text"
                    defaultValue={ranges.minimum.foam_test_3}
                    onChange={(e) =>
                      handleInputChange(
                        "Range",
                        "foam_test_3",
                        e.target.value,
                        null,
                        "minimum"
                      )
                    }
                    disabled={checkedRows?.[`Range_minimum`] || false}
                    style={inputStyle}
                  /> */}
                  {ranges.minimum.foam_test_3}
                </TableCell>
                <TableCell>
                  {" "}
                  {/* <input
                    type="text"
                    defaultValue={ranges.minimum.remark_time}
                    onChange={(e) =>
                      handleInputChange(
                        "Range",
                        "remark_time",
                        e.target.value,
                        null,
                        "minimum"
                      )
                    }
                    disabled={checkedRows?.[`Range_minimum`] || false}
                    style={inputStyle}
                  /> */}
                </TableCell>
                <TableCell rowSpan={2}>
                  {" "}
                  {/* <input
                    type="text"
                    value={hotConductivity || ""}
                    onChange={(e) => setHotConductivity(e.target.value)}
                    style={inputStyle}
                    disabled={
                      (checkedRows?.[`Range_minimum`] &&
                        checkedRows?.[`Range_maximum`]) ||
                      false
                    }
                  /> */}
                  {hotConductivity || ""}
                </TableCell>
                <TableCell rowSpan={2}>
                  {" "}
                  {/* <input
                    type="text"
                    defaultValue={coldConductivity}
                    onChange={(e) => setColdConductivity(e.target.value)}
                    style={inputStyle}
                    disabled={
                      (checkedRows?.[`Range_minimum`] &&
                        checkedRows?.[`Range_maximum`]) ||
                      false
                    }
                  /> */}
                  {coldConductivity}
                </TableCell>
                <TableCell>
                  {" "}
                  {/* <input
                    type="text"
                    value={ranges.minimum.minimumDate || ""}
                    onChange={(e) =>
                      handleInputChange(
                        "Range",
                        "modified_at",
                        e.target.value,
                        null,
                        "minimum"
                      )
                    }
                    style={inputStyle}
                    disabled
                  /> */}
                </TableCell>
                <TableCell>
                  {" "}
                  {/* <div className="d-flex justify-content-between align-items-center  gap-3">
                    {ranges.minimum.operator}
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={isRowChecked("Range", null, "minimum")}
                          onChange={() =>
                            handleCheckboxClick(
                              "Range",
                              null,
                              "minimum",
                              ranges.minimum.id
                            )
                          }
                          disabled={
                            ranges.minimum.supervisor && !is_supervisor
                              ? true
                              : false
                          }
                        />
                      }
                    />
                  </div> */}
                </TableCell>
                <TableCell rowSpan={5}>
                  {dippingData?.coagulant_parameter?.supervisor ? (
                    dippingData?.coagulant_parameter?.supervisor
                  ) : (
                    <Button
                      variant="contained"
                      size="small"
                      className="dipping-approve-btn"
                      title="Approve"
                      onClick={() => handleApprove()}
                      disabled={!areAllRowsChecked()}
                    ></Button>
                  )}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Maximum</TableCell>
                <TableCell>
                  {" "}
                  {/* <input
                    type="text"
                    defaultValue={ranges.maximum.temp}
                    onChange={(e) =>
                      handleInputChange(
                        "Range",
                        "temp",
                        e.target.value,
                        null,
                        "maximum"
                      )
                    }
                    disabled={checkedRows?.[`Range_maximum`] || false}
                    style={inputStyle}
                  /> */}
                  {ranges.maximum.temp}
                </TableCell>
                <TableCell>
                  {" "}
                  {/* <input
                    type="text"
                    defaultValue={ranges.maximum.specific_gravity}
                    onChange={(e) =>
                      handleInputChange(
                        "Range",
                        "specific_gravity",
                        e.target.value,
                        null,
                        "maximum"
                      )
                    }
                    disabled={checkedRows?.[`Range_maximum`] || false}
                    style={inputStyle}
                  /> */}
                  {ranges.maximum.specific_gravity}
                </TableCell>
                <TableCell>
                  {" "}
                  {/* <input
                    type="text"
                    defaultValue={ranges.maximum.foam_test_1}
                    onChange={(e) =>
                      handleInputChange(
                        "Range",
                        "foam_test_1",
                        e.target.value,
                        null,
                        "maximum"
                      )
                    }
                    disabled={checkedRows?.[`Range_maximum`] || false}
                    style={inputStyle}
                  /> */}
                  {ranges.maximum.foam_test_1}
                </TableCell>
                <TableCell>
                  {" "}
                  {/* <input
                    type="text"
                    defaultValue={ranges.maximum.foam_test_2}
                    onChange={(e) =>
                      handleInputChange(
                        "Range",
                        "foam_test_2",
                        e.target.value,
                        null,
                        "maximum"
                      )
                    }
                    disabled={checkedRows?.[`Range_maximum`] || false}
                    style={inputStyle}
                  /> */}
                  {ranges.maximum.foam_test_2}
                </TableCell>
                <TableCell>
                  {" "}
                  {/* <input
                    type="text"
                    defaultValue={ranges.maximum.foam_test_3}
                    onChange={(e) =>
                      handleInputChange(
                        "Range",
                        "foam_test_3",
                        e.target.value,
                        null,
                        "maximum"
                      )
                    }
                    disabled={checkedRows?.[`Range_maximum`] || false}
                    style={inputStyle}
                  /> */}
                  {ranges.maximum.foam_test_3}
                </TableCell>
                <TableCell>
                  {" "}
                  {/* <input
                    type="text"
                    defaultValue={ranges.maximum.remark_time}
                    onChange={(e) =>
                      handleInputChange(
                        "Range",
                        "remark_time",
                        e.target.value,
                        null,
                        "maximum"
                      )
                    }
                    disabled={checkedRows?.[`Range_maximum`] || false}
                    style={inputStyle}
                  /> */}
                </TableCell>
                <TableCell>
                  {" "}
                  {/* <input
                    type="text"
                    defaultValue={ranges.maximum.maximumDate}
                    onChange={(e) =>
                      handleInputChange(
                        "Range",
                        "modified_at",
                        e.target.value,
                        null,
                        "maximum"
                      )
                    }
                    style={inputStyle}
                    disabled
                  /> */}
                </TableCell>
                <TableCell>
                  {" "}
                  {/* <div className="d-flex justify-content-between align-items-center  gap-3">
                    {ranges.maximum.operator}
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={isRowChecked("Range", null, "maximum")}
                          onChange={() =>
                            handleCheckboxClick(
                              "Range",
                              null,
                              "maximum",
                              ranges.maximum.id
                            )
                          }
                          disabled={
                            ranges.maximum.supervisor && !is_supervisor
                              ? true
                              : false
                          }
                        />
                      }
                    />
                  </div> */}
                </TableCell>
              </TableRow>
              {[...Array(3)].map((_, index) => {
                const row =
                  dippingData?.coagulant_parameter?.coagulant_dipping_tank?.coagulant_dipping_tank?.find(
                    (tank) => tank.position === index
                  ) || {
                    position: index,
                  };
                const modifiedTankRow = [
                  ...(dippingData?.coagulant_parameter?.coagulant_dipping_tank
                    ?.coagulant_dipping_tank || []),
                ]
                  .filter((tank) => tank.modified_at)
                  .sort(
                    (a, b) => new Date(b.modified_at) - new Date(a.modified_at)
                  )[0];

                console.log("rowrow", modifiedTankRow);
                return (
                  <TableRow key={row?.position || index}>
                    {index === 0 && (
                      <TableCell rowSpan={3}>Dipping Tank</TableCell>
                    )}

                    {/* Dipping Tank Input fields */}
                    {/* <TableCell>
                      <input
                        type="text"
                        defaultValue={row.tank_type}
                        onChange={(e) =>
                          handleInputChange(
                            "DippingTank",
                            "tank_type",
                            e.target.value,
                            index,
                            "dippingTank"
                          )
                        }
                        disabled={
                          checkedRows?.[`DippingTank_${index}`] || false
                        }
                        style={inputStyle}
                      />
                    </TableCell> */}
                     <TableCell>
                    {DEFAULT_TANK_NAMES.DippingTank[index] || row?.temp}
                    </TableCell>
                    <TableCell>
                      <input
                        type="text"
                        defaultValue={row.temp}
                        onChange={(e) =>
                          handleInputChange(
                            "DippingTank",
                            "temp",
                            e.target.value,
                            index,
                            "dippingTank"
                          )
                        }
                        disabled={
                          checkedRows?.[`DippingTank_${index}`] || false
                        }
                        style={inputStyle}
                      />
                    </TableCell>
                    <TableCell>
                      <input
                        type="text"
                        defaultValue={row.specific_gravity}
                        onChange={(e) =>
                          handleInputChange(
                            "DippingTank",
                            "specific_gravity",
                            e.target.value,
                            index,
                            "dippingTank"
                          )
                        }
                        disabled={
                          checkedRows?.[`DippingTank_${index}`] || false
                        }
                        style={inputStyle}
                      />
                    </TableCell>
                    <TableCell>
                      <input
                        type="text"
                        defaultValue={row.foam_test_1}
                        onChange={(e) =>
                          handleInputChange(
                            "DippingTank",
                            "foam_test_1",
                            e.target.value,
                            index,
                            "dippingTank"
                          )
                        }
                        disabled={
                          checkedRows?.[`DippingTank_${index}`] || false
                        }
                        style={inputStyle}
                      />
                    </TableCell>
                    <TableCell>
                      <input
                        type="text"
                        defaultValue={row.foam_test_2}
                        onChange={(e) =>
                          handleInputChange(
                            "DippingTank",
                            "foam_test_2",
                            e.target.value,
                            index,
                            "dippingTank"
                          )
                        }
                        disabled={
                          checkedRows?.[`DippingTank_${index}`] || false
                        }
                        style={inputStyle}
                      />
                    </TableCell>
                    <TableCell>
                      <input
                        type="text"
                        defaultValue={row.foam_test_3}
                        onChange={(e) =>
                          handleInputChange(
                            "DippingTank",
                            "foam_test_3",
                            e.target.value,
                            index,
                            "dippingTank"
                          )
                        }
                        disabled={
                          checkedRows?.[`DippingTank_${index}`] || false
                        }
                        style={inputStyle}
                      />
                    </TableCell>
                    <TableCell>
                      <input
                        type="text"
                        defaultValue={row.remark_time}
                        onChange={(e) =>
                          handleInputChange(
                            "DippingTank",
                            "remark_time",
                            e.target.value,
                            index,
                            "dippingTank"
                          )
                        }
                        disabled={
                          checkedRows?.[`DippingTank_${index}`] || false
                        }
                        style={inputStyle}
                      />
                    </TableCell>

                    {/* Dipping Tank Conductivity */}
                    {index === 0 && (
                      <>
                        <TableCell rowSpan={3}>
                          <input
                            type="text"
                            defaultValue={dippingHotConductivity}
                            onChange={(e) =>
                              setDippingHotConductivity(e.target.value)
                            }
                            disabled={isRowChecked(
                              "DippingTank",
                              index,
                              "dippingTank"
                            )}
                            style={inputStyle}
                          />
                        </TableCell>
                        <TableCell rowSpan={3}>
                          <input
                            type="text"
                            defaultValue={dippingColdConductivity}
                            onChange={(e) =>
                              setDippingColdConductivity(e.target.value)
                            }
                            disabled={isRowChecked(
                              "DippingTank",
                              index,
                              "dippingTank"
                            )}
                            style={inputStyle}
                          />
                        </TableCell>
                        <TableCell rowSpan={3}>
                          <input
                            type="text"
                            defaultValue={
                              modifiedTankRow?.modified_at
                                ? dayjs(modifiedTankRow.modified_at).format(
                                    "HH:mm:ss"
                                  )
                                : ""
                            }
                            disabled
                            style={inputStyle}
                          />
                        </TableCell>
                      </>
                    )}
                    <TableCell>
                      <div className="d-flex justify-content-between align-items-center  gap-3">
                        {row?.operator || username}
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={isRowChecked(
                                "DippingTank",
                                index,
                                "dippingTank"
                              )}
                              onChange={() =>
                                handleCheckboxClick(
                                  "DippingTank",
                                  index,
                                  "dippingTank",
                                  row.id ? row.id : ""
                                )
                              }
                              disabled={
                                row?.supervisor && !is_supervisor ? true : false
                              }
                            />
                          }
                        />
                      </div>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
      <button className="mt-5 next-btn" onClick={handleSubmit}>
        Submit
      </button>
      {isApproved && (
        <div className="sendingdataaaa1">
          <Card className="pairingcard-Approved">
            <CardContent className="p-0 pairing-status">
              <h4>Are you sure you want to Approve?</h4>
            </CardContent>
            <button className="pairingcard-btn" onClick={handleSubmitData}>
              Yes
            </button>
            <button
              className="pairingcard-btn"
              onClick={() => setIsApproved(false)}
            >
              No
            </button>
          </Card>
        </div>
      )}
    </div>
  );
};

export default DippingCogulant;